module.exports = __webpack_public_path__ + "static/media/gallery-15.41eea596.jpg";